.icon-info-container {
  display: inline-flex;
  align-items: center;
}

.icon-info {
  color: #9fa0a4;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1024 1024'%3E%3Cpath fill='%239FA0A4' d='M512 128c212 0 384 172 384 384S724 896 512 896 128 724 128 512s172-384 384-384zm0 43c-189 0-341 152-341 341s152 341 341 341 341-152 341-341-152-341-341-341zm65 225h2c34 0 61-28 61-62 0-33-27-60-60-61-34-1-62 26-63 60s26 62 60 63zm0 265v-1c1-8-4-15-12-17-21 20-45 37-71 48-6 0-7-5-3-11l78-185c5-10 8-21 10-33-2-18-17-32-35-33-59 9-113 39-151 86-1 0-1 0-1 1-1 8 4 15 12 17 20-18 43-33 67-43v11l-78 187c-5 10-8 21-9 33 4 16 18 28 35 30 62-7 120-39 158-90z'/%3E%3C/svg%3E");
  display: inline-block;
  height: 24px;
  width: 24px;
}

.icon-info_small {
  width: 18px;
  height: 18px;
}

.icon-close {
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg viewBox='0 0 19 19' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cpath fill='%239FA0A4' fill-rule='evenodd' d='M13.1 13.1c-.28.28-.74.28-1.02 0l-2.7-2.68-2.8 2.8c-.28.3-.74.3-1.02 0a.7.7 0 0 1 0-1l2.8-2.83L5.7 6.7c-.3-.27-.3-.73 0-1 .27-.3.73-.3 1 0l2.7 2.67 2.55-2.55c.28-.3.74-.3 1.02 0 .28.28.28.73 0 1.02L10.42 9.4l2.68 2.68c.28.28.28.74 0 1.02m2.94-10.35c-3.66-3.67-9.63-3.67-13.3 0-3.66 3.66-3.66 9.62 0 13.3 3.67 3.65 9.63 3.65 13.3 0 3.66-3.68 3.66-9.64 0-13.3'%3E%3C/path%3E%3C/svg%3E");
  height: 20px;
  width: 20px;
}

.modal-overlay {
  box-sizing: border-box;
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(51, 51, 51, 0.6);
}

.modal-overlay *,
.modal-overlay *::before,
.modal-overlay *::after {
  box-sizing: inherit;
}

.modal-overlay.hidden {
  display: none;
}

.modal-wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  min-height: 100px;
  margin: 15px;
  padding: 15px;
  background-color: #ffffff;
}

.button-close {
  padding: 0;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  font-family: inherit;
  align-self: flex-end;
}

:host(:not([dir="rtl"])) .modal-icon-text {
  padding-left: 5px;
}

:host([dir="rtl"]) .modal-icon-text {
  padding-right: 5px;
}

.modal-icon-text:active {
  color: #626469;
}